import { render } from "./DealOrderBookTable.vue?vue&type=template&id=5a39de26&scoped=true"
import script from "./DealOrderBookTable.vue?vue&type=script&lang=js"
export * from "./DealOrderBookTable.vue?vue&type=script&lang=js"

import "./DealOrderBookTable.vue?vue&type=style&index=0&id=5a39de26&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a39de26"]])

export default __exports__